import { DepositModeKey } from 'services/recharges/recharges.types';
import { WithdrawalModeKey } from 'services/withdrawal/withdrawal.types';

export function calcGatewayCircuitComposeId(
  gatewayId: number,
  circuitId: number,
) {
  return `${gatewayId}_${circuitId}`;
}

export function getGatewayCircuitFromCompositeId(
  gatewayCircuitId: WithdrawalModeKey | DepositModeKey,
) {
  const [gatewayId, circuitId] = gatewayCircuitId
    .split('_')
    .slice(0, 2)
    .map(Number);
  return { gatewayId, circuitId };
}
